import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useTranslation } from 'react-i18next';
import { StatsPageInfo, StatCard } from '~/components/Shared/StatsPageInfo/StatsPageInfo';

interface AnnouncementsStatistics {
  total: number | null;
  awaiting: number | null;
  sent: number | null;
  archived: number | null;
}

interface Props {
  statusFilter: string;
  setStatusFilter: (value: string) => void;
}

const AllIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8h1a4 4 0 0 1 0 8h-1"/>
    <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/>
    <line x1="6" y1="1" x2="6" y2="4"/>
    <line x1="10" y1="1" x2="10" y2="4"/>
    <line x1="14" y1="1" x2="14" y2="4"/>
  </svg>
);

const AwaitingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

const SentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);

const ArchivedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="21 8 21 21 3 21 3 8"/>
    <rect x="1" y="3" width="22" height="5"/>
    <line x1="10" y1="12" x2="14" y2="12"/>
  </svg>
);

export const AnnouncementsPageInfo = ({ statusFilter, setStatusFilter }: Props) => {
  const { t } = useTranslation();

  const { data: stats } = useQuery<AnnouncementsStatistics>({
    queryFn: async () => {
      const response = await instance.get('admin/announcement-statistics');
      return response.data;
    },
    queryKey: ['announcement-statistics'],
  });

  const cards: StatCard[] = [
    { value: '', label: t('total'), count: stats?.total, color: 'purple', icon: <AllIcon /> },
    { value: '1', label: t('awaiting_shipment'), count: stats?.awaiting, color: 'orange', icon: <AwaitingIcon /> },
    { value: '2', label: t('sent'), count: stats?.sent, color: 'green', icon: <SentIcon /> },
    { value: '3', label: t('status_archived'), count: stats?.archived, color: 'gray', icon: <ArchivedIcon /> },
  ];

  return (
    <StatsPageInfo
      activeStatus={statusFilter}
      onStatusChange={setStatusFilter}
      cards={cards}
    />
  );
};
